import styled from 'styled-components'

import { Section as SectionGS } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { colors, media, radii, space } = theme

export const Section = styled(SectionGS)`
  padding-top: ${space['spacing-xxxl']};
  padding-bottom: ${space['spacing-xxxl']};
  overflow: hidden;

  h2 {
    margin-bottom: ${space['spacing-md']};
  }

  > * {
    padding: 0;

    > div:first-child {
      padding: 0 ${space['spacing-md']};
    }
  }

  @media (${media.tablet}) {
    padding-top: ${space['spacing-giga']};
    padding-bottom: ${space['spacing-giga']};

    > * {
      padding: 0 ${space['spacing-md']};

      > div:first-child {
        padding: unset;
      }
    }
  }
`

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};
  margin-bottom: ${space['xl']};

  h2 {
    margin-bottom: 0;
  }

  @media (${media.tablet}) {
    text-align: center;
  }
`

export const BackgroundLine = styled.div`
  height: 3px;
  background: ${colors['blue-background-strong-default']};
  position: absolute;
  top: 40px;
  left: 0%;
  right: -6%;
  z-index: 0;
  pointer-events: none;
`

export const CarouselWrapper = styled.div`
  padding-top: ${space['spacing-sm']};
  padding-bottom: ${space['spacing-md']};

  & > div:first-child {
    width: 100%;
    overflow: unset;
  }

  .swiper-slide:first-child {
    ${BackgroundLine} {
      left: 5%;
    }
  }

  .swiper-slide:last-child {
    ${BackgroundLine} {
      right: 5%;
    }
  }
`

export const Slide = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['spacing-lg']};
  width: 100%;
  height: 100%;
  cursor: default;
`

export const IconWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  min-height: 80px;
  height: 80px;
  background-color: ${colors['blue-background-strong-default']};
  border-radius: ${radii['corner-radius-circular']};
`

export const ImageContainer = styled.div`
  position: relative;
  inset: 0;
  transition: inherit;
  z-index: 0;
  height: 180px;
  pointer-events: none;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, rgb(0 34 75 / 80%) 0%, rgb(0 0 0 / 0%) 40%);
    transition: all 0.3s ease;
    overflow: hidden;
    z-index: 1;
    opacity: 0;
  }
`

export const CardWrapper = styled.div`
  position: relative;
  width: 90%;
  height: 100%;
  border: 1px rgb(141 198 255) solid;
  border-radius: ${radii['corner-radius-md']};
  transition: all 0.3s ease;
  cursor: grab;
  overflow: hidden;

  &:hover {
    transform: scale(1.05);

    ${ImageContainer} {
      transform: scale(1.05);

      &::after {
        opacity: 1;
      }
    }
  }
`

export const CardContent = styled.div`
  position: relative;
  overflow: hidden;
`

export const TextWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xs']};
  padding: ${space['spacing-md']};
  z-index: 2;
`

export const CtaWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${space['spacing-xl']};
  padding: 0 ${space['spacing-md']};

  .ds-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${space['spacing-lg']};
    width: 100%;
    min-height: ${space['spacing-mega']};
    border-radius: ${radii['corner-radius-pill']};
    background-color: ${colors['blue-background-strong-default']};

    svg {
      width: ${space['spacing-md']};
      height: ${space['spacing-md']};
    }
  }

  @media (${media.tablet}) {
    padding: 0;

    .ds-button {
      width: 21.875rem;
    }
  }
`
